import script from "./NkGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./NkGroup.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__